import { useEffect } from 'react';
import { useAppStore } from '../store/appStore';
import { AssetCard } from '../components/assets/AssetCard';
import { Loader2, Inbox } from 'lucide-react';

export function GalleryPage() {
  const { assets, loading, error, totalAssets, fetchAssets, semanticUnavailable } = useAppStore();

  useEffect(() => {
    fetchAssets();
  }, [fetchAssets]);

  if (loading && assets.length === 0) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <Loader2 size={32} className="animate-spin text-violet-400 mx-auto" />
          <p className="text-slate-500 mt-3 text-sm">加载资产中...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center max-w-md">
          <p className="text-red-400 text-sm">{error}</p>
          <p className="text-slate-500 text-xs mt-2">请确保后端服务已启动</p>
        </div>
      </div>
    );
  }

  if (assets.length === 0) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <Inbox size={48} className="text-slate-700 mx-auto" />
          <h2 className="text-lg font-medium text-slate-400 mt-4">暂无资产</h2>
          <p className="text-slate-500 text-sm mt-2">
            使用 <code className="text-violet-400 bg-slate-800 px-1.5 py-0.5 rounded">vesp add</code> 或拖拽文件开始导入
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6">
      {semanticUnavailable && (
        <div className="mb-4 flex items-start gap-2 text-xs text-amber-400/90 bg-amber-500/10 border border-amber-500/20 rounded-lg px-3 py-2">
          <span className="mt-0.5">⚡</span>
          <span>语义搜索服务未就绪（需先启动 <code className="bg-amber-500/20 px-1 rounded">vesp daemon</code>），当前已回退到关键词搜索</span>
        </div>
      )}
      {/* Header stats */}
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl font-semibold text-slate-100">资产库</h2>
          <p className="text-sm text-slate-500 mt-0.5">{totalAssets} 项资产</p>
        </div>
      </div>

      {/* Masonry Grid */}
      <div className="masonry-grid">
        {assets.map((asset) => (
          <AssetCard key={asset.vesp_id} asset={asset} />
        ))}
      </div>
    </div>
  );
}
